import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { RootStore, RootStoreContext } from '../../stores/rootStore';

export default function Logout() {
    const { userStore }: RootStore = useContext(RootStoreContext);
    const navigate = useNavigate();

    useEffect(() => {
        userStore.Logout().then(() => navigate('/'));
    }, [navigate, userStore]);

    return null;
}
